/**
 * CheckboxListCard — shared card for the two criteria checklists
 * (40% Criteria, Referral Criteria). Plain checkbox rows with the
 * dashed separators from the Figma; no recalc participation.
 */
import type { FC } from "react";
import { Checkbox } from "@tricura/atlas-ui";
import { FormGroup } from "../../../../components/form-group";
import type { CriterionItem } from "../premium-selection-types";
import { CardRows } from "./field-row";

interface CheckboxListCardProps {
    title: string;
    icon?: FC<{ className?: string }>;
    items: readonly CriterionItem[];
    checked: Record<string, boolean>;
    onToggle: (id: string, next: boolean) => void;
    /** Custom attribute for E2E testing — applied to the card; each row gets
     *  `${dataAutotest}-${item.id}-checkbox`. */
    "data-autotest"?: string;
}

export function CheckboxListCard({ title, icon, items, checked, onToggle, "data-autotest": dataAutotest }: CheckboxListCardProps) {
    return (
        <FormGroup title={title} icon={icon} data-autotest={dataAutotest}>
            <CardRows>
                {items.map((item) => (
                    <div key={item.id} className="py-2.5">
                        <Checkbox
                            size="sm"
                            label={item.label}
                            isSelected={Boolean(checked[item.id])}
                            onChange={(next) => onToggle(item.id, next)}
                            data-autotest={dataAutotest ? `${dataAutotest}-${item.id}-checkbox` : undefined}
                        />
                    </div>
                ))}
            </CardRows>
        </FormGroup>
    );
}
